import BaseFormPresenter from "../../../../../base/BaseFormPresenter";

class WasteRawFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
}

export default WasteRawFormPresenter;
